angular
  .module('data-ng-path-item')
  .constant('OptionBuilderDTD', {
    id: 'key',
    item: 'key',
    rank: 'integer',
    text: 'html',
    _action: {
      type: 'object',
      optional: true
    }
  })
  .factory('OptionBuilder', function OptionBuilder(Interface, OptionBuilderDTD) {
    return function OptionDTO(data) {
      Interface.implement(OptionBuilderDTD, data, this);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/builders/option_builder.js